import { Cookies } from 'react-cookie'
import _ from 'lodash'
import store from '../redux/store'
import { getFirebaseCustomerId } from '../api/firebase/firebaseAuthentication'
import {
  BOOST2_PROMO_CODE,
  BOOST_PROMO_CODE,
  COOKIE_CUSTOMER_ID,
  LOYALTY,
  MODIFY_ORDER_TYPE_PROMOTION,
  WEBAPP,
} from '../constants'
import { isStringNotNull } from './dataType'
import moment from 'moment'
import { getLoyaltyCashback } from '../components/Loyalty/Loyalty.services.js'
import { deleteUserPromotion } from '../api/users'
import { deleteDeviceUsedPromotion } from '../api/device'
import { PROMO_CODE_STATUS } from '../constants/promotions'

export const getCreditCard = () => {
  const { user } = store.getState().userReducer;
  const { cards } = user;
  if (cards) {
    return _.find(cards, (card) => {
      return card.selected;
    });
  }
};

export const checkMinBasketPrice = (codePromotion, totalPriceOrder) => {
  let minBasketPrice = null;
  if (codePromotion === LOYALTY) {
    const { loyalty } = store.getState().configurationReducer;
    minBasketPrice = loyalty?.cashbackConfig?.minBasket || 0;
  } else {
    const { promotions } = store.getState().shopReducer;
    minBasketPrice = promotions?.[codePromotion]?.minBasketPrice;
  }
  if (!minBasketPrice || totalPriceOrder >= minBasketPrice) return null;
  else return minBasketPrice;
};

export const isPromotionValid = (promotion) => {
  const { orderType } = store.getState().pendingOrderReducer;

  return (
    promotion &&
    (promotion?.canals ? promotion.canals?.includes(WEBAPP) : true) &&
    (promotion.orderTypes ? promotion.orderTypes.includes(orderType) : true)
  );
};

export const getPromotion = (totalPriceOrder) => {
  const { promotions } = store.getState().userReducer.user;
  const customerId = getFirebaseCustomerId();
  const {
    promotions: shopPromotions,
    shopId,
    loyalty: loyaltyShop,
  } = store.getState().shopReducer;
  const { loyalty } = store.getState().configurationReducer;
  let promoPath;
  const { orders } = store.getState().orderReducer;

  if (promotions) {
    const promotionData = _.find(promotions, (promo, ppath) => {
      const { promotion = {} } = promo;
      const { promoCode, shopId: promoShopId, isGeneralData } = promotion;
      const promoCodeUsed = _.find(orders, (order) => {
        const { promotion } = order;
        return promotion && promotion?.promoCode === promoCode;
      });
      promoPath = ppath;
      const shopMatches = isGeneralData || !promoShopId || shopId === promoShopId;
      return shopMatches && promo.status === PROMO_CODE_STATUS.IN_PROGRESS && !promoCodeUsed;
    });
    if (promotionData) {
      const { promotion } = promotionData;
      const minBasketPrice = checkMinBasketPrice(
        promotion?.promoCode,
        totalPriceOrder
      );
      switch (promotion?.promoCode) {
        case LOYALTY: {
          const isUsable =
            !!getLoyaltyCashback(loyalty) && !loyaltyShop.disabled;
          return isUsable ? { ...promotion, minBasketPrice } : null;
        }
        case BOOST_PROMO_CODE: {
          return promotion;
        }
        case BOOST2_PROMO_CODE: {
          const pendingOrder = store.getState().pendingOrderReducer;
          const { basketReactivation } = store.getState().configurationReducer;
          if (!basketReactivation?.enabled) {
            deleteUserPromotion(customerId, promoPath);
            break;
          }
          const expired = pendingOrder.lastUpdateOrder &&
            basketReactivation?.enabled &&
            moment().diff(pendingOrder.lastUpdateOrder, 'hours') >
            basketReactivation?.expireIn
          if (expired) {
            deleteUserPromotion(customerId, promoPath);
            break;
          } else return promotion;
        }
        default: {
          const foundPromotion =
            promotion?.reconversionType === MODIFY_ORDER_TYPE_PROMOTION.REFUND
              ? promotion
              : shopPromotions?.[promotion?.promoCode];
          const isExpired = foundPromotion?.expired;
          const isDateRangeInvalid =
            foundPromotion?.startedDate &&
            foundPromotion?.endedDate &&
            !moment().isBetween(
              foundPromotion.startedDate,
              foundPromotion.endedDate,
              undefined,
              '[]'
            );
          if (isExpired || isDateRangeInvalid) {
            deleteUserPromotion(customerId, promoPath);
            deleteDeviceUsedPromotion(customerId, promoPath);
          } else if (isPromotionValid(foundPromotion)) {
            return { ...foundPromotion, minBasketPrice };
          }
        }
      }
    }
  }
};

export function validatePhone(telephone) {
  const re =
    /^[\s()+-]*([0-9][\s()+-]*){6,20}(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?$/i;
  return re.test(String(telephone).toLowerCase());
}

export const getCookieCustomerId = () => {
  return new Cookies().get(COOKIE_CUSTOMER_ID);
};

export const setCookieCustomerId = (customerId) => {
  const cookies = new Cookies();
  cookies.set(COOKIE_CUSTOMER_ID, customerId);
};

export const resetCookieCustomerId = () => {
  const cookies = new Cookies();
  cookies.remove(COOKIE_CUSTOMER_ID);
};

export const getWebViewCustomerId = () => {
  return window.location.pathname.split('/')[3];
};

export const getCustomerTableNb = () => {
  return window.location.pathname.split('/')[3];
};

export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const formatPhone = (phone, countryCode = '+33') => {
  if (isStringNotNull(phone)) {
    if (phone.startsWith('0') && phone.length > 1) {
      phone = phone.replace('0', countryCode);
    } else if (!phone.startsWith('+') && phone.length > 1) {
      phone = countryCode + phone;
    }
    phone = phone.replace(/ /g, '');
  }
  return phone;
};

export const phoneNumberMinLength = (iso2) => {
  const minLengths = {
    fr: 9,
    be: 8,
    us: 10,
    no: 8,
    mc: 8,
    sw: 7,
    al: 8,
    de: 11,
  };
  return minLengths[iso2] || 5;
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
